import { useQuery } from '@tanstack/react-query';

import { supabase } from '@/lib/supabase';
import type { CourseWithFullDetails } from '@/lib/types';
import { sortFocusSkillsByOrder } from '@/lib/utils';

export function useGetMapCourse(courseId: string | null) {
	return useQuery<CourseWithFullDetails | null>({
		queryKey: ['get-map-course', courseId],

		queryFn: async () => {
			if (!courseId) return null;

			const { data, error } = await supabase
				.from('courses')
				.select(
					`
					course_name,
					course_id,
					course_description,
					course_resource_info,
					course_extras,
					course_prereq,
					last_updated,
					courses_outcomes (
						courses_outcomes_id,
						outcome:outcomes (
							outcome_order,
							outcome_text,
							outcome_id
						)
					),
					courses_resources (
						course_resources_id,
						resource:resources (
							resource_author,
							resource_detail,
							resource_isbn,
							resource_id,
							resource_title,
							resource_type
						)
					),
					courses_focuses (
						courses_focuses_id,
						focus:focuses (
							focus_title,
							focus_type,
							focus_order,
							focus_id,
							focuses_skills (
								focuses_skills_id,
								skill_order,
								skill:skills (
									skill_id,
									skill_text,
									skill_type
								)
							)
						)
					)
				`
				)
				.eq('course_id', courseId)
				.maybeSingle();

			if (error) throw error;

			sortFocusSkillsByOrder(data?.courses_focuses ?? null);

			return data as CourseWithFullDetails | null;
		},

		enabled: !!courseId,
		staleTime: Infinity,
	});
}
